<ion-card class="card-shadow-7" 
                    style="border-radius: 0.5em;height: 100% !important"
                   >
                   
                   <ion-grid class="ion-no-padding" style="color: black;">
                    <ion-row  style="background: var(--ion-color-temp-permit);">
                      <ion-col style="padding: 0.4em;">
                        <ion-label class="card-header-unique">TEMP PERMIT</ion-label>
                      </ion-col>
                    </ion-row>
                    <ion-row>
                      <ion-col style="padding: 0.5em;">
                        <ion-label class="card-header-unique">#{{tempPermit['permitNo']}}</ion-label>
                      </ion-col>
                    </ion-row>
                    <ion-row>
                      <ion-col class="ion-no-padding">
                       <h1 style="padding: 0.5em;margin: 0;" class="paragraph-bold"> <ion-icon
                        style="vertical-align: middle; font-size: x-large;"
                        name="location-outline"
                      ></ion-icon
                      >{{tempPermit['LotName']}}</h1>
                      </ion-col>
                    </ion-row>
                    <ion-row>
                      <ion-col>
                        <ion-item lines="none">
                        <ion-label class="ion-text-wrap">
                          <ion-grid>
                            <ion-row>
                              <ion-col style="text-align: left">
                                <ion-label class="paragraph-regular" *ngIf="tempPermit.endTime==null && !tempPermit.sameDay">
                                  {{tempPermit['StartDate']| date:dataService.settings['system']['datemask']}} - {{tempPermit['EndDate'] | date:dataService.settings['system']['datemask']}}
                                   
                                </ion-label>
                                <ion-label class="paragraph-regular" *ngIf="tempPermit.endTime==null && tempPermit.sameDay">
                                  {{tempPermit['StartDate']| date:dataService.settings['system']['datemask']}}
                                   
                                </ion-label>
                                <ion-label class="paragraph-regular" *ngIf="tempPermit.endTime!=null && !tempPermit.sameDay">
                                  {{tempPermit['startTime']| date:'h:mm a'}}, {{tempPermit['StartDate']| date:dataService.settings['system']['datemask']}} - {{tempPermit['endTime'] | date:'h:mm a'}}, {{tempPermit['EndDate'] | date:dataService.settings['system']['datemask']}}
                                   
                                </ion-label>
                                <ion-label class="paragraph-regular" *ngIf="tempPermit.endTime!=null && tempPermit.sameDay">
                                 {{tempPermit['StartDate']| date:dataService.settings['system']['datemask']}},<br> {{tempPermit['startTime']| date:'h:mm a'}} - {{tempPermit['endTime'] | date:'h:mm a'}}
                                   
                                </ion-label>
                               
                              </ion-col>
                              
                            </ion-row>
                          </ion-grid>

                        </ion-label>
                        <span class="paragraph-bold" style="text-align: right;" class="ion-text-wrap">
                          {{tempPermit['Amount'] | currency}}
                        </span>
                      </ion-item>
                      </ion-col>
                    </ion-row>
                   
                   </ion-grid>
                  
                     </ion-card>